import { Slide } from "@jelly/lesson";
import { task as task01 } from "../../../../../task/course-05/lesson-11/task-01";

const task: Slide = {
  titleHtml: `Connect objective parameters on the left with the corresponding perceptual<br>dimensions on the right by dragging lines from point to point.`,
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
